<template>
  <div style="padding: 10px;">
    <el-row>
      <el-col :span="9" :offset="1">
        <div>
          <img src="@/assets/AntofagastaMinerals.jpg" class="logo">
        </div>
      </el-col>
      <el-col :span="6" class="infoRole">
        <div v-if="this.$route.path !== '/es/seleccionar-roles'">
          <b
            v-if="!$store.getters.role.admin"
          >{{ bhpProfiles[$store.getters.role.role] || $store.getters.role.role }}</b>
          <b v-if="$store.getters.role.admin === true">Administrador del sistema</b>
          <i class="el-icon-info cursor info" @click="roleDescriptionView = true"></i>
        </div>
      </el-col>
      <el-col :span="8">
        <Roles :roles="$store.getters.roles" :currentRole="$store.getters.role"/>
      </el-col>
    </el-row>

    <el-dialog
      append-to-body
      :title="$store.getters.role.role ? reviewerRoles[$store.getters.role.role] : 'Administrador de Plataforma'"
      :visible.sync="roleDescriptionView"
      width="30%"
    >
      <br>
      <div
        v-if="$store.getters.role.admin"
      >Este perfil permite realizar la gestión interna de la plataforma, permitiendo así ejecutar cambios en cada una de las funcionalidades del sistema.</div>
      <div v-else>
        <div
          v-if="reviewerRoles[$store.getters.role && $store.getters.role.role]"
        >Perfil que es asignado para realizar la revisión de un inventario de riesgos.</div>
        <div
          v-if="coordinatorRoles[$store.getters.role && $store.getters.role.role]"
        >Perfil que es asignado ya sea para realizar la creación de un inventario de riesgos o para corregirlos.</div>
      </div>
      <span slot="footer">
        <el-button
          type="primary"
          size="small"
          @click="roleDescriptionView = false"
        >{{ $t('Cancelar') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { includes } from "lodash";
import Roles from "./Roles.vue";
import { reviewerRoles, coordinatorRoles } from "@/utils/generalObjects";

const FAENAS_ESCONDIDA = [
  "5a6345a53ad308a85c17a118",
  "5a6f78337b772dcfe68241d5"
];

export default {
  name: "navbar",
  data() {
    return {
      reviewerRoles,
      coordinatorRoles,
      roleDescriptionView: false,
      bhpProfiles: {
        hse: "Asesor SSO",
        health: "Especialista de Salud",
        safety: "Especialista de Seguridad",
        environment: "Especialista de Medioambiente",
        contractor_hse: "Asesor SSO Contratista",
        owner: "Dueño de Contrato",
        contract_owner: "Dueño de Contrato",
        risk: "Especialista de Riesgo",
        administrator: "Administrador de Contrato",
        contractor_coordinator: "Coordinador Contratista",
        coordinator: "Coordinador",
        manager: "Gerente de Área",
        super: "Superintendente de Área",
        general_manager: "Gerente General",
        superadmin: "Administrador del sistema"
      }
    };
  },
  components: {
    Roles
  },
  computed: {
    isEscondida() {
      try {
        return includes(FAENAS_ESCONDIDA, this.$store.getters.role.faena_id);
      } catch (error) {
        console.log(error)
      }
    }
  }
};
</script>

<style scoped>
.mt-10 {
  margin-top: 10px;
}
.escondida {
  margin-top: 15px;
  width: 250px;
}
.bhp {
  margin-top: 13px;
  width: 105px;
}
.username {
  font-weight: 800;
  font-size: 18px;
}
.user-info {
  font-size: 14px;
}
.centrar {
  text-align: center;
}
.infoRole {
  margin-top: 15px;
  color: black;
  font-size: 25px;
}
.cursor {
  cursor: pointer;
}
.info {
  margin-left: 5px;
  font-size: 18px !important;
}
.logo {
  width: 175px;
}
</style>
